<script>
    import { onMount } from "svelte";
    import * as api from "../utiles/api";
    import * as store from "../stores/store";
    import * as Common from "../utiles/common.util";
    import { push } from "svelte-spa-router";
    import { PushNotifications } from "@capacitor/push-notifications";
    import { Capacitor } from "@capacitor/core";
    import { Preferences } from "@capacitor/preferences";

    onMount(() => {
        // 로그인 상태 체크
        apiGetStatus();
    });

    async function apiGetStatus() {
        if (Capacitor.isNativePlatform()) {
            const permStatus = await PushNotifications.requestPermissions();

            if (permStatus.receive !== "granted") {
                //alert("푸시 알림 권한이 거부되었습니다.");
                return;
            }
        }

        const token = await Common.getStoredToken();

        if (token) {
            if (location.href.includes("Login")) {
                push("/AsList");
            }
        } else {
            if (!location.href.includes("Login")) {
                push("/Login");
            }
        }
    }

    async function logout() {
        try {
            await api.get(`/account/logout`);
        } catch (err) {
            console.error("logout api error", err);
            // api 실패해도 무시하고 진행
        }

        // 스토어 초기화
        store.accountInfo.set(null);
        store.jwt_token.set(null);
        store.refreshToken.set(null);

        // Preferences 초기화
        try {
            await Preferences.clear();
        } catch (err) {
            console.error("Preferences clear error", err);
        }

        // 로그인 페이지로 이동
        push("/Login");
    }
</script>

<!-- svelte-ignore a11y-missing-attribute -->
<!-- svelte-ignore a11y-click-events-have-key-events -->
<div class="custom-theme-btm btm-container">
    <div
        class="btm-item {window.location.hash.startsWith('#/As') ? 'active' : ''}"
        on:click={() => {
            if (window.location.hash === "#/AsList") {
                window.location.reload();
            } else {
                push("/AsList");
            }
        }}
    >
        <div class="icon-wrapper">
            <img
                src="../img/{window.location.hash.startsWith('#/As')
                    ? 'ico_btm_list_on.png'
                    : 'ico_btm_list.png'}"
            />
        </div>
        <p>리스트</p>
    </div>

    <div
        class="btm-item {window.location.hash.startsWith('#/Partner')
            ? 'active'
            : ''}"
        on:click={() => {
            if (window.location.hash === "#/PartnerList") {
                window.location.reload();
            } else {
                push("/PartnerList");
            }
        }}
    >
        <div class="icon-wrapper">
            <img
                src="../img/{window.location.hash.startsWith('#/Partner')
                    ? 'ico_btm_bcnc_on.png'
                    : 'ico_btm_bcnc.png'}"
            />
        </div>
        <p>업체관리</p>
    </div>

    <div class="btm-item" on:click={logout}>
        <div class="icon-wrapper">
            <img src="../img/ico_btm_logout.png" />
        </div>
        <p>로그아웃</p>
    </div>
</div>

<style>
    /* 상위 클래스를 활용한 우선순위 강화 */
    .custom-theme-btm.btm-container {
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        max-width: 1024px;
        margin: 0 auto;
        height: 70px; /* 약간 더 높게 조정 */
        display: flex;
        justify-content: space-around;
        align-items: center;
        background-color: var(--bg-secondary) !important;
        border-top: 1px solid var(--border-color) !important;
        box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
        z-index: 100;
        padding-bottom: env(safe-area-inset-bottom); /* 아이폰 등 노치 대응 */
    }

    .custom-theme-btm .btm-item {
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        transition: all 0.2s ease;
        height: 100%;
    }

    .custom-theme-btm .icon-wrapper {
        width: 24px;
        height: 24px;
        margin-bottom: 4px;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: transform 0.2s ease;
    }

    .custom-theme-btm .btm-item img {
        width: 100%;
        height: 100%;
        object-fit: contain;
        /* 다크모드에서 아이콘이 너무 안 보일 경우를 대비한 필터 (필요 시) */
    }

    .custom-theme-btm .btm-item p {
        font-size: 11px;
        font-weight: 500;
        color: var(--text-tertiary) !important;
        margin: 0;
        transition: color 0.2s ease;
    }

    /* 활성화 상태 스타일 */
    .custom-theme-btm .btm-item.active p {
        color: var(--color-primary) !important;
        font-weight: 700;
    }

    .custom-theme-btm .btm-item.active .icon-wrapper {
        transform: translateY(-2px);
    }

    /* 다크모드에서의 아이콘 명시성 확보를 위한 처리 */
    :global([data-theme="dark"]) .custom-theme-btm .btm-item:not(.active) img {
        filter: brightness(1.2) opacity(0.6); /* 밝기를 높이고 투명도를 조절하여 가독성 확보 */
    }
</style>
